import { render } from "./HeroiconsSolidDocumentDownload.vue?vue&type=template&id=292175b8"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocumentDownload.vue"]])

export default __exports__